export const basketWidth = {
  regular: 544,
  superWideDesktop: 560,
}
